import { Alert } from '@cmsgov/ds-medicare-gov'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

export function BillsNoResultsAlert ({ className }: {className?: string}) {
  const { t } = useTranslation('premiumsBills')

  return (
    <Alert heading={t('noResultsAlert.heading')} className={classNames('ds-u-measure--wide', className)}>
        {t('noResultsAlert.content')}
    </Alert>
  )
}
